import { defaultRssSetting } from "../../../config/constants";
import { FLIP_CLOCK_SETTINGS } from "../../../Constants/clock";

const initialState = {
  // Dialog Controls
  createDialog: false,
  prayerEnableDialog: false,

  // Prayer Data
  isLoading: false,
  data: { next: 0, location: "" },

  // RSS Data
  selectedFeed: {},
  newSeparator: null,
  rssSettings: defaultRssSetting,
  selectedRss: {},
  isCreation: true,
  rssName: "Instance Name",

  // weather
  weatherData: {},
  isEditingWeather: false,
  weatherTextColor: "#f2f2f2ff",
  weatherBgColor: "#3c5fb1",
  weatherCardColor: "rgba(255, 255, 255, 0.1)",

  // clock
  clockSettings: FLIP_CLOCK_SETTINGS,
  clockData: {},
  clockDisplay: "FULL_SCREEN",
  isEditingClock: false,
};

export default initialState;
